// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background: #0e101c;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
}

h1 {
  font-weight: 100;
  color: white;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 1px solid rgb(79, 98, 148);
}

.form {
  background: #0e101c;
  max-width: 400px;
  margin: 0 auto;
}

p {
  color: #bf1650;
}

/* p::before {
  display: inline;
  content: "⚠ ";
} */
/* 
input {
  display: block;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  border: 1px solid white;
  padding: 10px 15px;
  margin-bottom: 10px;
  font-size: 14px;
} */

/* label {
  line-height: 2;
  text-align: left;
  display: block;
  margin-bottom: 13px;
  margin-top: 20px;
  color: white;
  font-size: 14px;
  font-weight: 200;
} */

.pink_button button[type="submit"],
.pink_button input[type="submit"] {
  background: #ec5990;
  color: white;
  text-transform: uppercase;
  border: none;
  margin-top: 40px;
  padding: 20px;
  font-size: 16px;
  font-weight: 100;
  letter-spacing: 10px;
}

.pink_button button[type="submit"]:hover,
.pink_button input[type="submit"]:hover {
  background: #bf1650;
}

.pink_button button[type="submit"]:active,
.pink_button input[type="button"]:active,
.pink_button input[type="submit"]:active {
  transition: 0.3s all;
  transform: translateY(3px);
  border: 1px solid transparent;
  opacity: 0.8;
}

.pink_button input:disabled {
  opacity: 0.4;
}

.pink_button input[type="button"]:hover {
  transition: 0.3s all;
}

/* button[type="submit"],
input[type="button"],
input[type="submit"] {
  -webkit-appearance: none;
} */
/* 
.App {
  max-width: 600px;
  margin: 0 auto;
} */

button[type="button"] {
  display: block;
  appearance: none;
  background: #333;
  color: white;
  border: none;
  text-transform: uppercase;
  padding: 10px 20px;
  border-radius: 4px;
}

hr {
  margin-top: 30px;
}

/* button {
  display: block;
  appearance: none;
  margin-top: 40px;
  border: 1px solid #333;
  margin-bottom: 20px;
  text-transform: uppercase;
  padding: 10px 20px;
  border-radius: 4px;
} */

.spinner {
  /* position: absolute; */
  display: flex;
  justify-content: center;
  height: 50vh;
  width: 50vw;
  background-color: white;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
}

#logo-spinner {
  animation: spin 2000ms linear infinite;
  transition: transform 0.1s ease-out;
  backface-visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB;;cAEY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;GAGG;AACH;;;;;;;;;;GAUG;;AAEH;;;;;;;;;GASG;;AAEH;;EAEE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,oBAAoB;EACpB,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;GAIG;AACH;;;;GAIG;;AAEH;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,2BAA2B;AAC7B","sourcesContent":["body {\n  background: #0e101c;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n}\n\nh1 {\n  font-weight: 100;\n  color: white;\n  text-align: center;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgb(79, 98, 148);\n}\n\n.form {\n  background: #0e101c;\n  max-width: 400px;\n  margin: 0 auto;\n}\n\np {\n  color: #bf1650;\n}\n\n/* p::before {\n  display: inline;\n  content: \"⚠ \";\n} */\n/* \ninput {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  border-radius: 4px;\n  border: 1px solid white;\n  padding: 10px 15px;\n  margin-bottom: 10px;\n  font-size: 14px;\n} */\n\n/* label {\n  line-height: 2;\n  text-align: left;\n  display: block;\n  margin-bottom: 13px;\n  margin-top: 20px;\n  color: white;\n  font-size: 14px;\n  font-weight: 200;\n} */\n\n.pink_button button[type=\"submit\"],\n.pink_button input[type=\"submit\"] {\n  background: #ec5990;\n  color: white;\n  text-transform: uppercase;\n  border: none;\n  margin-top: 40px;\n  padding: 20px;\n  font-size: 16px;\n  font-weight: 100;\n  letter-spacing: 10px;\n}\n\n.pink_button button[type=\"submit\"]:hover,\n.pink_button input[type=\"submit\"]:hover {\n  background: #bf1650;\n}\n\n.pink_button button[type=\"submit\"]:active,\n.pink_button input[type=\"button\"]:active,\n.pink_button input[type=\"submit\"]:active {\n  transition: 0.3s all;\n  transform: translateY(3px);\n  border: 1px solid transparent;\n  opacity: 0.8;\n}\n\n.pink_button input:disabled {\n  opacity: 0.4;\n}\n\n.pink_button input[type=\"button\"]:hover {\n  transition: 0.3s all;\n}\n\n/* button[type=\"submit\"],\ninput[type=\"button\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: none;\n} */\n/* \n.App {\n  max-width: 600px;\n  margin: 0 auto;\n} */\n\nbutton[type=\"button\"] {\n  display: block;\n  appearance: none;\n  background: #333;\n  color: white;\n  border: none;\n  text-transform: uppercase;\n  padding: 10px 20px;\n  border-radius: 4px;\n}\n\nhr {\n  margin-top: 30px;\n}\n\n/* button {\n  display: block;\n  appearance: none;\n  margin-top: 40px;\n  border: 1px solid #333;\n  margin-bottom: 20px;\n  text-transform: uppercase;\n  padding: 10px 20px;\n  border-radius: 4px;\n} */\n\n.spinner {\n  /* position: absolute; */\n  display: flex;\n  justify-content: center;\n  height: 50vh;\n  width: 50vw;\n  background-color: white;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n\n#logo-spinner {\n  animation: spin 2000ms linear infinite;\n  transition: transform 0.1s ease-out;\n  backface-visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
